import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import styles from '../../styles/desktop.css';

import type { IWrapperDeps, IWrapperProps } from './models';
import { Wrapper as Component } from './wrapper';

export const WrapperDesktop = createWidget<IWrapperDeps, IWrapperProps>({ styles })(Component);
